module.exports = __webpack_public_path__ + "media/images/paisage_autumn-414437ff63a986c94fbdf2f959272911.png";